import React from 'react';
import { SlidersHorizontal } from 'lucide-react';

const SORT_OPTIONS = [
  { value: 'newest', label: 'Newest' },
  { value: 'price_asc', label: 'Price: Low to High' },
  { value: 'price_desc', label: 'Price: High to Low' },
  { value: 'discount', label: 'Highest Discount' },
];

export function ShopToolbar({ filters, activeFilterCount, filtersOpen, setFiltersOpen, updateFilter }) {
  return (
    <div className="flex items-center justify-between mb-8 gap-4">
      <button
        onClick={() => setFiltersOpen(!filtersOpen)}
        className="lg:hidden flex items-center gap-2 border border-[#E5E5E5] px-4 py-2.5 text-xs uppercase tracking-wider font-work text-[#0A0A0A] hover:border-[#D4AF37] transition-colors"
        data-testid="filter-toggle-btn"
      >
        <SlidersHorizontal size={14} />
        Filters {activeFilterCount > 0 && `(${activeFilterCount})`}
      </button>

      <div className="flex-1 max-w-sm">
        <input
          type="text"
          value={filters.search}
          onChange={e => updateFilter('search', e.target.value)}
          placeholder="Search products or designers..."
          className="w-full border border-[#E5E5E5] focus:border-[#D4AF37] outline-none px-4 py-2.5 text-sm font-work text-[#0A0A0A]"
          data-testid="shop-search"
        />
      </div>

      <select
        value={filters.sort_by}
        onChange={e => updateFilter('sort_by', e.target.value)}
        className="border border-[#E5E5E5] focus:border-[#D4AF37] outline-none px-4 py-2.5 text-xs uppercase tracking-wider font-work text-[#0A0A0A] bg-white cursor-pointer"
        data-testid="sort-select"
      >
        {SORT_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  );
}
